module.exports = __webpack_public_path__ + "static/media/harp-arpeggio.5a5c0a94.webm";